import store from '../../../sales-conversation/src/store/redux/store';
import { resetRecommendations } from '../store/redux/slices/recommendationSlice';
import { resetSelection } from '../store/redux/slices/selectionSlice';

interface ResetState {
  reset: () => void;
}

const useRiskAnalysisResetState = (): ResetState => {
  const reset = () => {
    store.dispatch(resetRecommendations());
    store.dispatch(resetSelection());
  };

  return { reset };
};

export default useRiskAnalysisResetState;
